module.exports = __webpack_public_path__ + "media/images/xpass/xpass-bg-b927c685094ee29a2bf2b5a9a5da5376.svg";